import { Subscription } from "./Subcription";
import { Status } from "./Status";
import { CardInfo } from "./CardInfo";
import { Coupon } from "./Coupon";
import { NextPaymentInfo } from "./NextPaymentInfo";
import { Entitlement } from "../Entitlement";
import { User } from "../User";

export interface BillingInfo {
  subscription?: Subscription;
  card?: CardInfo;
  coupons?: Coupon[];
  nextPayment?: NextPaymentInfo;
  scaTokenSecret?: string;
}

export const isDefaultPlan = (billingInfo: BillingInfo) => {
  return billingInfo.subscription && billingInfo.subscription.plan.default;
};

/** @deprecated */
export const isValidSubscription = (u: User, billingInfo?: BillingInfo) => {
  if (u.betaStatus === "active") {
    return true;
  }
  const subscriptionValid =
    billingInfo?.subscription &&
    (billingInfo?.subscription.status === Status.ACTIVE ||
      billingInfo?.subscription.status === Status.CANCELING ||
      billingInfo?.subscription.status === Status.TRIALING);
  return subscriptionValid /*&& !billingInfo.subscription?.plan.default FIXME REMOVE*/;
};

export const isValidEntitlement = (entitlement?: Entitlement) => {
  const subscriptionValid =
    entitlement?.subscription &&
    (entitlement?.subscription.status === Status.ACTIVE ||
      entitlement?.subscription.status === Status.CANCELING ||
      entitlement?.subscription.status === Status.TRIALING);
  return subscriptionValid /*&& !billingInfo.subscription?.plan.default FIXME REMOVE*/;
};
